import { Injectable } from '@angular/core';

export interface TokenPair {
  accessToken: string;
  refreshToken: string;
}
export interface Appid {
  appId: string;
}

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  get ok() { return typeof window !== 'undefined'; }
  private APPID = 'appId';
  private ACCESS = 'accessToken';
  private REFRESH = 'refreshToken';

  // ถ้าคุณใช้ appId อยู่แล้ว
  getAppId(): string | null {
    return this.ok ? sessionStorage.getItem(this.APPID) : null;
  }

  setAppId(appId: string) {
    if (this.ok) {
      sessionStorage.setItem(this.APPID, appId);
    }
  }

  getAccessToken(): string | null {
    return this.ok ? sessionStorage.getItem(this.ACCESS) : null;
  }
  getRefreshToken(): string | null {
    return this.ok ? sessionStorage.getItem(this.REFRESH) : null;
  }

  setTokens(tokens: TokenPair) {
    if (this.ok) {
      sessionStorage.setItem(this.ACCESS, tokens.accessToken);
      sessionStorage.setItem(this.REFRESH, tokens.refreshToken);
    }
  }

  clearTokens() {
    if (this.ok) {
      sessionStorage.removeItem(this.ACCESS);
      sessionStorage.removeItem(this.REFRESH);
    }
  }

  getSession(key: string) {
    return this.ok ? sessionStorage.getItem(key) : null;
  }
  setSession(key: string, value: string) {
    if (this.ok) sessionStorage.setItem(key, value);
  }
  removeSession(key: string) {
    if (this.ok) sessionStorage.removeItem(key);
  }


  getLocalStorage(key: string) {
    return this.ok ? localStorage.getItem(key) : null;
  }
  setLocalStorage(key: string, value: string) {
    if (this.ok) localStorage.setItem(key, value);
  }
  removeLocalStorage(key: string) {
    if (this.ok) localStorage.removeItem(key);
  }
}
